export default __webpack_public_path__ + "static/media/faamLarge.a1c2dabc.png";